import "./index.css";
import { StagingBanner } from "@/components/layout/StagingBanner";
import { AppProviders } from "@/providers/AppProviders";

export function App() {
  return (
    <>
      <AppProviders />
      <StagingBanner />
    </>
  );
}

export default App;
